import React from 'react';
import { Modal, Form, Input } from 'antd';

const EditDatabaseModal = ({ visible, onOk, onCancel, fieldType, currentValue }) => {
  const [form] = Form.useForm();
  const handleSubmit = () => {
    form.validateFields().then((values) => {
      console.log(`修改的字段类型: ${fieldType}, 新值: ${values[fieldType]}`);


      fetch(`//dai.caihuiltd.com/api/update-user/${currentValue.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        body: JSON.stringify(values),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          console.log('Success:', data);
        })
        .catch(error => {
          console.error('Error updating database:', error);
        });
      onOk(values);
    }).catch((info) => {
      console.log('校验失败:', info);
    });
  };

  return (
    <Modal
      title="Modify user information"
      open={visible}
      onOk={handleSubmit}
      onCancel={onCancel}
      okText="Save changes"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical" initialValues={currentValue}>
        {fieldType === "name" && (
          <Form.Item label="Modify user name" name="name">
            <Input />
          </Form.Item>
        )}
        {fieldType === "email" && (
          <Form.Item label="Modify user email" name="email">
            <Input type="email" />
          </Form.Item>
        )}
        {fieldType === "password" && (
          <Form.Item label="Modify user password" name="password">
            <Input />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default EditDatabaseModal;